import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useSnackbar } from "notistack";
import Layout from "../Layout/Layout";
import { APIUrl } from "../../Helper/APIUrl";

function ManageFurnishingMaster() {
  const Token = JSON.parse(localStorage.getItem("tcn"));
  const localStorageUserId = JSON.parse(localStorage.getItem("userid"));
  const { enqueueSnackbar } = useSnackbar();

  const [search, setSearch] = useState("");
  const [furnishings, setFurnishings] = useState([]);
  const [filteredFurnishings, setFilteredFurnishings] = useState([]);
  const [szTypes, setSzTypes] = useState([]);

  const [FurnishId, setFurnishId] = useState(0);
  const [TypeId, setTypeId] = useState(0);
  const [FurninshName, setFurninshName] = useState("");
  const [IsActive, setIsActive] = useState(true);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [edit, setEdit] = useState(false);

  const typeInputRef = useRef(null);
  const nameInputRef = useRef(null);
  const imageInputRef = useRef(null);

  const parseJSON = async (response) => {
    try {
      if (response.status === 204 || response.status === 205) return null;
      const text = await response.text();
      if (!text) return null;
      return JSON.parse(text);
    }
    catch (error) {
      console.warn("Failed to parse JSON response", error);
      return null;
    }
  };

  const getImageSource = (imagePath) => {
    if (!imagePath) return "";
    if (String(imagePath).startsWith("http")) return imagePath;
    if (String(imagePath).startsWith("Assets/")) return `${APIUrl.BaseUrl}/${imagePath}`;
    return `${APIUrl.BaseUrl}/${String(imagePath).replace(/^\//, "")}`;
  };

  const resetForm = () => {
    if (imagePreview && imagePreview.startsWith("blob:")) {
      URL.revokeObjectURL(imagePreview);
    }

    setFurnishId(0);
    setTypeId(0);
    setFurninshName("");
    setIsActive(true);
    setImageFile(null);
    setImagePreview("");
    setEdit(false);

    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
  };

  const getAllsztypes = async () => {
    try {
      const response = await fetch(APIUrl.SZType + "GetAllSZType", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify({}),
      });
      debugger;
      const result = await parseJSON(response);
      const filterResult = result.data.filter(x => x.SectionId == 45);
      const records = Array.isArray(filterResult) ? [...filterResult].sort((a, b) => b.TypeId - a.TypeId) : [];
      setSzTypes(records);
    }
    catch (error) {
      console.log(error);
      setSzTypes([]);
    }
  };

  const getAllFurnishings = async () => {
    try {
      const response = await fetch(APIUrl.Furnishing + "GetAllFurnishing", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify({}),
      });

      const result = await parseJSON(response);
      const records = Array.isArray(result?.data) ? result.data : [];
      setFurnishings(records);
      setFilteredFurnishings(records);
    }
    catch (error) {
      console.log(error);
      setFurnishings([]);
      setFilteredFurnishings([]);
    }
  };

  useEffect(() => {
    if (!Token) {
      enqueueSnackbar("Please login first", { variant: "warning" });
      return;
    }

    getAllsztypes();
    getAllFurnishings();
  }, []);

  useEffect(() => {
    const value = search.toLowerCase();
    const result = furnishings.filter((row) => {
      const typeName = (row.TypeName || "").toLowerCase();
      const furnishName = (row.FurninshName || "").toLowerCase();
      const status = row.IsActive ? "activated" : "deactivated";
      return typeName.includes(value) || furnishName.includes(value) || status.includes(value);
    });

    setFilteredFurnishings(result);
  }, [search, furnishings]);

  useEffect(() => {
    return () => {
      if (imagePreview && imagePreview.startsWith("blob:")) {
        URL.revokeObjectURL(imagePreview);
      }
    };
  }, [imagePreview]);

  const handleImageChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      enqueueSnackbar("Only JPG, JPEG, PNG, or WEBP files are allowed.", { variant: "warning" });
      event.target.value = "";
      return;
    }

    if (imagePreview && imagePreview.startsWith("blob:")) {
      URL.revokeObjectURL(imagePreview);
    }

    const preview = URL.createObjectURL(file);
    setImageFile(file);
    setImagePreview(preview);
  };

  const validateForm = () => {
    if (!TypeId || Number(TypeId) === 0) {
      enqueueSnackbar("Please select a SZ type.", { variant: "warning" });
      typeInputRef.current?.focus();
      return false;
    }

    if (!FurninshName || FurninshName.trim().length < 2) {
      enqueueSnackbar("Furnishing name is required.", { variant: "warning" });
      nameInputRef.current?.focus();
      return false;
    }

    return true;
  };

  const buildFormData = () => {
    const formData = new FormData();
    formData.append("FurnishId", String(FurnishId || 0));
    formData.append("TypeId", String(TypeId || 0));
    formData.append("FurninshName", FurninshName || "");
    formData.append("IsActive", String(Boolean(IsActive)));
    formData.append("ModifyBy", String(localStorageUserId || 0));
    formData.append("CreatedBy", String(localStorageUserId || 0));

    if (imageFile) {
      formData.append("image", imageFile, imageFile.name);
    }

    return formData;
  };

  const insertFurnishing = async () => {
    try {
      if (!validateForm()) return;

      const formData = buildFormData();
      const response = await fetch(APIUrl.Furnishing + "InsertFurnishingWithOptionalIcon", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: formData,
      });

      const result = await parseJSON(response);
      if (response.ok && (result?.Success || result?.returnID !== undefined || result?.FurnishId !== undefined)) {
        enqueueSnackbar(result?.Message || "Successfully Added", { variant: "success" });
        await getAllFurnishings();
        resetForm();
        return;
      }

      enqueueSnackbar(result?.Message || "Failed to add furnishing.", { variant: "error" });
    }
    catch (error) {
      console.log(error);
      enqueueSnackbar("Error while adding furnishing.", { variant: "error" });
    }
  };

  const updateFurnishing = async () => {
    try {
      if (!validateForm()) return;

      const formData = buildFormData();
      const response = await fetch(APIUrl.Furnishing + "UpdateFurnishingWithOptionalIcon/" + FurnishId, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: formData,
      });

      const result = await parseJSON(response);
      if (response.ok && result) {
        enqueueSnackbar("Successfully Updated", { variant: "success" });
        await getAllFurnishings();
        resetForm();
        return;
      }

      enqueueSnackbar(result?.Message || "Failed to update furnishing.", { variant: "error" });
    }
    catch (error) {
      console.log(error);
      enqueueSnackbar("Error while updating furnishing.", { variant: "error" });
    }
  };

  const editFurnishing = (row) => {
    setFurnishId(row.FurnishId || 0);
    setTypeId(row.TypeId || 0);
    setFurninshName(row.FurninshName || "");
    setIsActive(row.IsActive ?? true);
    setImageFile(null);
    setImagePreview(getImageSource(row.IconImage));
    setEdit(true);

    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }

    nameInputRef.current?.focus();
  };

  const activateDeactivateFurnishing = async (id, action) => {
    try {
      const payload = {
        FurnishId: id,
        Value: action,
        ModifyBy: localStorageUserId || 0,
      };

      const response = await fetch(APIUrl.Furnishing + "ActivateDeactivateFurnishing/" + id, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await parseJSON(response);
      if (response.ok && result) {
        enqueueSnackbar(action === "activate" ? "Successfully Activated" : "Successfully Deactivated", {
          variant: action === "activate" ? "success" : "warning",
        });
        await getAllFurnishings();
        return;
      }

      enqueueSnackbar(result?.Message || "Failed to update furnishing status.", { variant: "error" });
    }
    catch (error) {
      console.log(error);
      enqueueSnackbar("Error while changing furnishing status.", { variant: "error" });
    }
  };

  const columns = [
    {
      name: "SNo.",
      selector: (_, index) => index + 1,
      width: "80px",
    },
    {
      name: "Type Name",
      selector: (row) => row.TypeName,
      sortable: true,
      grow: 2,
    },
    {
      name: "Furnishing Name",
      selector: (row) => row.FurninshName,
      sortable: true,
      grow: 2,
    },
    {
      name: "Image",
      grow: 2,
      cell: (row) =>
        row.IconImage ? (
          <img
            src={getImageSource(row.IconImage)}
            alt={row.FurninshName || "Furnishing"}
            className="h-16 w-24 object-cover rounded-md border border-gray-200 my-2"
          />
        ) : (
          <span className="text-xs text-gray-500">No image</span>
        ),
    },
    {
      name: "Status",
      cell: (row) =>
        row.IsActive ? (
          <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Activated</label>
        ) : (
          <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">Deactivated</label>
        ),
      grow: 1,
    },
    {
      name: "Action",
      grow: 1,
      cell: (row) => (
        <div className="flex items-center gap-2 py-2">
          <Button
            onClick={() => editFurnishing(row)}
            className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-2"
            title="Edit Furnishing"
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
          </Button>

          {row.IsActive ? (
            <Button
              onClick={() => activateDeactivateFurnishing(row.FurnishId, "deactivate")}
              className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-3 py-2"
              title="Deactivate Furnishing"
            >
              <i className="fa fa-toggle-on" aria-hidden="true"></i>
            </Button>
          ) : (
            <Button
              onClick={() => activateDeactivateFurnishing(row.FurnishId, "activate")}
              className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-3 py-2"
              title="Activate Furnishing"
            >
              <i className="fa fa-toggle-off" aria-hidden="true"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <Layout>
      <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
        <div className="space-y-6">
          <div className="rounded-2xl border border-indigo-200 bg-gradient-to-r from-indigo-600 via-indigo-700 to-purple-600 p-6 text-white shadow-lg">
            <p className="text-sm uppercase tracking-[0.2em] text-indigo-100">Manage Furnishing</p>
            {/* <h2 className="mt-2 text-2xl font-semibold">Manage Furnishing</h2>
            <p className="mt-2 max-w-3xl text-sm text-indigo-100/90">
              Create and maintain furnishing references, attach an optional icon, and toggle the active state from the list.
            </p> */}
          </div>

          <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
              <div>
                <label className="mb-2 block text-sm font-medium text-gray-700">SZ Type</label>
                <select
                  ref={typeInputRef}
                  value={TypeId}
                  onChange={(e) => setTypeId(Number(e.target.value))}
                  className="w-full rounded-lg border border-gray-300 px-4 py-3 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  <option value={0}>Select SZ Type</option>
                  {szTypes.map((item) => (
                    <option key={item.TypeId} value={item.TypeId}>
                      {item.TypeName}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="mb-2 block text-sm font-medium text-gray-700">Furnishing Name</label>
                <input
                  ref={nameInputRef}
                  type="text"
                  value={FurninshName}
                  onChange={(e) => setFurninshName(e.target.value)}
                  placeholder="Enter furnishing name"
                  className="w-full rounded-lg border border-gray-300 px-4 py-3 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>

              <div>
                <label className="mb-2 block text-sm font-medium text-gray-700">Icon Image</label>
                <input
                  ref={imageInputRef}
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="w-full rounded-lg border border-gray-300 px-4 py-2"
                />
              </div>
            </div>

            {imagePreview ? (
              <div className="mt-4">
                <p className="mb-2 text-sm font-medium text-gray-700">Preview</p>
                <img
                  src={imagePreview}
                  alt="Furnishing preview"
                  className="h-28 w-44 rounded-md border border-gray-200 object-cover"
                />
              </div>
            ) : null}

            <div className="mt-6 flex flex-col gap-4 sm:flex-row">
              {!edit ? (
                <Button
                  onClick={insertFurnishing}
                  className="rounded-lg bg-indigo-600 px-6 py-3 font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  Add Furnishing
                </Button>
              ) : (
                <Button
                  onClick={updateFurnishing}
                  className="rounded-lg bg-indigo-600 px-6 py-3 font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  Update Furnishing
                </Button>
              )}

              <button
                type="button"
                onClick={resetForm}
                className="rounded-lg bg-gray-600 px-6 py-3 font-medium text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
              >
                Reset
              </button>
            </div>
          </div>

          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
            <DataTable
              title="Get All Furnishing"
              columns={columns}
              data={filteredFurnishings}
              pagination
              fixedHeader
              fixedHeaderScrollHeight="550px"
              highlightOnHover
              subHeader
              subHeaderAlign="right"
              subHeaderComponent={
                <input
                  type="text"
                  placeholder="Search type, furnishing or status"
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 sm:w-72"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              }
            />
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default ManageFurnishingMaster;
